import { Component, OnInit } from "@angular/core";
import { environment } from "@app/../environments/environment";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { SessionKey } from "@shared/clickar-constants";
import { ScriptService } from "@shared/services/script.service";
import { StorageManagerService } from "@shared/services/storage/storage-manager.service";
import { TemplateService } from "@shared/services/template/template.service";
import { WcmService } from "@shared/services/wcm/wcm.service";
import { take } from "rxjs";
@Component({
	selector: "app-private-footer",
	templateUrl: "./private-footer.component.html",
	styleUrl: "./private-footer.component.scss",
	standalone: false
})
export class PrivateFooterComponent implements OnInit {
	footer: any;
	reader2 = new FileReader();
	market: string;
	partner = true;

	constructor(
		protected wcmService: WcmService,
		public translate: TranslateService,
		private templateService: TemplateService,
		private storageService: StorageManagerService,
		private scriptService: ScriptService
	) {
		if (!(this.market = this.storageService.getSessionItem(
			SessionKey.GEOLOCATION_MARKET,
			""
		)))
			translate.onLangChange.pipe(take(1)).subscribe((event: LangChangeEvent) => {
				this.market = event.lang.slice(3).toUpperCase();
			});
	}

	ngOnInit() {
		this.refreshPartner();
		this.translate.onLangChange.subscribe((/* event: LangChangeEvent */) => {
			this.loadscript();
		});
	}
	refreshPartner() {
		this.templateService
			.getPartnersOpenUsingGET(this.market.toUpperCase())
			.subscribe(value => {
				this.partner = value.length > 0;
			});
	}

	loadscript() {
		if (!environment.mobile) {
			const currentLang = this.translate.getCurrentLang();
			let lang = currentLang.slice(0, 2).toUpperCase(),
				mkt: string,
				scriptPromise: Promise<{ script: string; loaded: boolean; status: string; }>;
			this.scriptService.removeScript();
			switch (lang) {
				case "EN":
				// Falls through
				case "ES":
				// Falls through
				case "IT":
				// Falls through
				case "PL":
				// Falls through
				case "PT":
					this.scriptService.loadScript(lang, "css");
					scriptPromise = this.scriptService.loadScript(lang, "script");
					break;
				case "DE":
					/* mkt = currentLang.slice(3).toLowerCase(); TODO: Loading DE also for AT. When de-AT will be available, uncomment this comment
					if (mkt === "AT") {
						lang = "AT";
					}
					*/
					this.scriptService.loadScript(lang, "css");
					scriptPromise = this.scriptService.loadScript(lang, "script");
					break;

				case "NL":
					mkt = currentLang.slice(3).toLowerCase();
					if (mkt === "BE") {
						lang = "NL-BE";
					}
					this.scriptService.loadScript(lang, "css");
					scriptPromise = this.scriptService.loadScript(lang, "script");
					break;
				case "FR":
					mkt = currentLang.slice(3).toLowerCase();
					switch (mkt) {
						case "BE":
							lang = "FR-BE";
							break;
						case "LU":
							lang = "LU";
					}
					this.scriptService.loadScript(lang, "css");
					scriptPromise = this.scriptService.loadScript(lang, "script");
			}
			scriptPromise?.then(status => { // manually triggering cookie script, since it probably didn't load by itself
				setTimeout(() => { // letting some time to parse the script
					if (status.loaded === true && !window["initDone"] && window["init"]) {
						window["init"]();
					}
				}, 50);
			});
		}
	}
}